export const TimeToFormat = (timeStamp) => {
  let now = (new Date()).getTime(); //获取当前的时间
  let date = new Date(timeStamp);
  let sendTime = date.getTime(); //将时间转换为时间戳
  let time = (now - sendTime)/1000;

  if (time < 60 && time >= 0) {
    return "刚刚";
  } else if (time >= 60 && time < 3600) {
    return (time / 60).toFixed(0) + "分钟前";

  } else if (time >= 3600 && time < 3600 * 24) {
    return (time / 3600 ).toFixed(0)+ "小时前";

  } else if (time >= 3600 * 24 && time < 3600 * 24 * 30) {
    return (time / 3600 / 24).toFixed(0) + "天前";

  } else if (time >= 3600 * 24 * 30 && time < 3600 * 24 * 30 * 12) {
    return (time / 3600 / 24 / 30 ).toFixed(0) + "个月前";

  } else if (time >= 3600 * 24 * 30 * 12) {
    return (time / 3600 / 24 / 30 / 12).toFixed(0) + "年前";

  } else {
    return "刚刚";
  }
}

// export const getYearWeek = (date) =>{
//   //将日期转换成yyyy-mm-dd格式
//   date = new Date(date);
//   let weekStartDate = getWeekStartByDate(date);//一周开始时间
//   var endDate = getDateFromDay(weekStartDate,6);//一周结束时间
//   if(weekStartDate.getFullYear()!=endDate.getFullYear()) return 1;
//   let date2 = new Date(date.getFullYear(), 0, 1);
//   let day1 = date.getDay();
//   if (day1 == 0) day1 = 7;
//   let day2 = date2.getDay();
//   if (day2 == 0) day2 = 7;
//   let d = Math.round((date.getTime() - date2.getTime() + (day2 - day1) * (24 * 60 * 60 * 1000)) / 86400000);
//   return Math.ceil(d / 7)+1;
// }

// 日期格式化将日期改为YY-MM-DD
export function getYearWeek(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    
  }
  const time_str = format.replace(/{(y|m|d)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

const getWeekStartByDate = (date) =>{
  let day = date.getDay();
  return getDateFromDay(date,-day);

}
const getDateFromDay=(dayDate , day)=>{
  let date = new Date();
  date.setTime(dayDate.getTime() + day * 24 * 60 * 60 * 1000);
  return date;
}

// const sortDataArray=(dataArray)=>{
//   return dataArray.sort(function (a,b) {
//     return Date.parse(b.date.replace(/-/9,'/'))-Date.parse(b.date.replace(/-/9,'/'))
//   })
// }



// WEBPACK FOOTER //
// ./src/utils/TimeToFormat.js